<template>
    <div class="checklist-section">
        <div v-for="(value, key) in node" :key="key" class="checklist-group">

            <div class="checklist-group-header">
                <h6 class="checklist-group-title">{{ key }}</h6>
                <span class="checklist-group-count">{{ stats(value).completed }}/{{ stats(value).total }}</span>
            </div>

            <ul v-if="isItemList(value)" class="checklist-items">
                <li v-for="(entry, index) in value" :key="index" class="checklist-item">
                    <label class="checklist-item-label">
                        <input type="checkbox" v-model="entry.completed" :disabled="!editable">
                        <span :class="{ 'checklist-item-done': entry.completed }">{{ entry.item }}</span>
                    </label>
                </li>
            </ul>

            <checklist-section v-else :node="value" :editable="editable" class="checklist-subsection" />

        </div>
    </div>
</template>

<script>
export default {
    name: 'ChecklistSection',
    props: {
        node: {
            type: [Array, Object],
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isItemList(value) {
            return Array.isArray(value);
        },
        stats(value) {
            if (Array.isArray(value)) {
                return {
                    total: value.length,
                    completed: value.filter(entry => entry.completed).length
                };
            }

            return Object.values(value || {}).reduce((acc, child) => {
                const childStats = this.stats(child);
                acc.total += childStats.total;
                acc.completed += childStats.completed;
                return acc;
            }, { total: 0, completed: 0 });
        }
    }
}
</script>

<style scoped>
.checklist-group {
    margin-bottom: 16px;
}

.checklist-group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eef0f4;
    padding-bottom: 4px;
    margin-bottom: 8px;
}

.checklist-group-title {
    margin: 0;
    font-weight: 600;
}

.checklist-group-count {
    font-size: 12px;
    color: #7c8ba1;
}

.checklist-items {
    list-style: none;
    padding-left: 4px;
    margin: 0;
}

.checklist-item {
    padding: 4px 0;
}

.checklist-item-label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;
    cursor: default;
}

.checklist-item-label input[type="checkbox"] {
    margin-top: 3px;
}

.checklist-item-done {
    color: #7c8ba1;
    text-decoration: line-through;
}

.checklist-subsection {
    padding-left: 16px;
}
</style>
